module.exports = __webpack_public_path__ + "img/social1.e0b577d6.svg";